<template>
  <div class="layout-blog-filters">
    <div class="container">
      <div class="categories">
        <slot name="category"></slot>
      </div>
      <div class="sort-wrapper">
        <slot name="sort"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.layout-blog-filters {
  margin-bottom: 40px;
}
.container,
.sort-wrapper,
.categories {
  display: flex;
  align-items: center;
  gap: 5px;
}
.categories {
  margin-right: auto;
}
a {
  border: solid 1px var(--light);
  font-weight: 500;
  padding: 10px 15px;
  border-radius: 100px;
  cursor: pointer;
  transition: 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  &:hover {
    background: var(--light);
  }
  &.active {
    background: var(--color);
    color: #fff;
    border-color: var(--color);
  }
  svg {
    &.up {
      transform: rotate(180deg);
    }
  }
}
@media screen and (max-width: 767px) {
  .layout-blog-filters {
    margin-top: -50px;
    text-align: center;
  }
  a {
    padding: 5px 10px;
    font-size: 14px;
  }
  .container {
    display: block;
    padding: 0 15px;
  }
  .container,
  .sort-wrapper,
  .categories {
    justify-content: center;
    flex-flow: wrap;
  }
  .categories {
    margin-bottom: 20px;
  }
}
</style>
